angular.module('manageconfigSysManagementJlglhModule', ['manageconfigSysManagementJlglRouterModule']).controller('manageconfigSysManagementJlglCtrl',
    [
        '$scope',
        'trsHttpService',
        'tManageMentService',
        function ($scope, trsHttpService, tManageMentService) {
            initStatus();
            initData();

            /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 10,
                    ITEMCOUNT: 0,
                    PAGECOUNT: 1,
                };
                $scope.data = {
                    status: {
                        '0': '启用',
                        '1': '停用'
                    },
                    docTypeJsons: [
                        {
                            name: '全部状态',
                            value: ''
                        },
                        {
                            name: '停用',
                            value: '1'
                        },
                        {
                            name: '启用',
                            value: '0'
                        }
                    ],
                    tenantName: {
                        TENANTCOUNT: '租户总数',
                        STOPTENANTCOUNT: '停用租户',
                        USERCOUNT: '用户数使用',
                        SITECOUNT: '站点使用',
                        CAPACITY: '容量使用(G)'
                    },
                    tenant: {}, // 租户使用情况
                    items: [], // 租户列表数据
                };
                // 查询租户列表
                $scope.params = {
                    serviceid: 'mlf_tenant',
                    methodname: 'queryTenants',
                    CurrPage: $scope.page.CURRPAGE,
                    PageSize: $scope.page.PAGESIZE,
                    STATUS: '', // 1停用 0启用
                    SEARCHVALUE: '' // 检索字段
                };
            }

            /**
             * [initData description]
             *
             * @return  {[type]}  [return description]
             */
            function initData() {
                initDropDown();
                getTenantClassify();
                getTenantList();
            }

            /**
             * [initDropDown description]
             *
             * @return  {[type]}  [return description]
             */
            function initDropDown() {
                $scope.data.docType = angular.copy($scope.data.docTypeJsons[0]);
            }

            /**
             * [getTenantClassify description]获取顶部租户使用情况
             *
             * @return  {[type]}  [return description]
             */
            function getTenantClassify() {
                var params = {
                    serviceid: 'mlf_tenantmesaureinfo',
                    methodname: 'tenantMeasureInfo'
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then((data) => {
                    $scope.data.tenant = data;
                });
            }

            /**
             * [queryByDropdown description]
             *
             * @return  {[type]}  [return description] 类型筛选
             */
            $scope.queryByDropdown = function() {
                $scope.page.CURRPAGE = $scope.params.PAGEINDEX = '1';      
                $scope.params.STATUS = $scope.data.docType.value;
                getTenantList();
            };

            /**
             * [getTenantList description]
             *
             * @return  {[type]}  [return description]
             */
            function getTenantList() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then((data) => {
                    $scope.data.items = data.DATA;
                });
            }

            /**
             * [showTenantInfo description]
             *
             * @param   {[type]}  item  [item description]展示租户信息
             *
             * @return  {[type]}        [return description]
             */
            $scope.showTenantInfo = function(item) {
                tManageMentService.showTenantInfo(item);
            };

            /**
            * [fullTextSearch description]
            *
            * @param   {[type]}  ev  [ev description]
            *
            * @return  {[type]}      [return description]
            */
            $scope.fullTextSearch = function(ev) {
                if ((ev && ev.keyCode === 13) || !ev) {
                    $scope.page.CURRPAGE = $scope.params.PAGEINDEX = '1';      
                    getTenantList();
                }
            };
            $scope.setBilling = function(item) {
                tManageMentService.packageDetail(item);
            };
            $scope.pageChanged = function() {
                $scope.params.PAGEINDEX = $scope.page.CURRPAGE;
            }
        },

    ]);
